export default __webpack_public_path__ + "static/SRF Carasweet 5S7706 - Fiche de spécifications et données techniques-e4d00cc5d3a69547457e266a38ad9371.pdf";